<template>
  <div>
    <!-- 单外订单---录入订单 -->
    <el-row>
      <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="{ span: 12, offset: 0 }">
        <ul>
          <li><span>客户</span>：{{ titleData.CUSTOMER_NAME }}</li>
          <li><span>项目点</span>：{{ titleData.PROJECT_NAME }}</li>
          <li><span>档口</span>：{{ titleData.DK_NAME }}</li>
        </ul>
      </el-col>
      <el-col :xs="12" :sm="12" :md="12" :lg="{ span: 12, offset: 0 }" :xl="{ span: 12, offset: 0 }">
        <ul>
          <li><span>送货日期</span>：{{ titleData.SEND_DAY }}</li>
          <li><span>总金额</span>：{{ totalFee }}</li>
        </ul>
      </el-col>
    </el-row>
    <el-row>
      <!-- 远程查询和添加数据-->
      <el-form :inline="true" class="demo-form-inline" style="margin: 0" :model="firstFormadd" ref="formRef" @submit.native.prevent size="medium">
        <el-form-item label="产品名称：">
          <el-autocomplete @keyup.enter.native="handelTab(1, $event)" ref="input1" class="inline-input" v-model="firstFormadd.productName"
            :fetch-suggestions="querySearchadd" placeholder="输入产品名称添加" :trigger-on-focus="false" @select="handleSelect" clearable>
          </el-autocomplete>
        </el-form-item>
        <el-form-item label="产品编码：">
          <el-autocomplete @keyup.enter.native="handelTab(2, $event)" ref="input2" class="inline-input" v-model="firstFormadd.productCode"
            :fetch-suggestions="querySearchCodeadd" placeholder="输入产品编码添加" :trigger-on-focus="false" @select="handleSelectCode" clearable>
          </el-autocomplete>
        </el-form-item>
        <el-form-item label="单位：">
          <el-input style="width: 80px" v-model="addForm.TYPE_UNIT" disabled></el-input>
        </el-form-item>
        <el-form-item label="单价：">
          <el-input @keyup.enter.native="handelTab(3, $event)" ref="input3" v-model="addForm.PRICE"></el-input>
        </el-form-item>
        <el-form-item label="订购数量：">
          <el-input @keyup.enter.native="handelTab(4, $event)" ref="input4" v-model="addForm.PRODUCT_COUNT">
          </el-input>
        </el-form-item>
        <el-form-item label="备注：">
          <label slot="label">备&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;注：</label>
          <el-input @keyup.enter.native="handelTabSp" ref="input5" v-model="addForm.PRODUCT_COMMENT" maxlength="20" show-word-limit>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button style="display: inline-block" @keydown.enter.native="handelTabKeyDown" @click="handelTabSpClick">
            确 定
          </el-button>
          <el-button style="display: inline-block" @click="launchAllOrder"> 发起订单 </el-button>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row>
      <el-col>
        <el-table border stripe :data="tableData" style="margin-top: 20px">
          <el-table-column label="序号" type="index" width="50"></el-table-column>
          <el-table-column label="产品编码" prop="PRODUCT_CODE"></el-table-column>
          <el-table-column label="产品名称" prop="NAME"></el-table-column>
          <el-table-column label="单位" prop="TYPE_UNIT"></el-table-column>
          <el-table-column label="单价" prop="PRICE">
            <template slot-scope="scope">
              <el-input v-model="scope.row.PRICE" @change="setActualNumber(scope.row)" clearable>
              </el-input>
            </template>
          </el-table-column>
          <el-table-column label="订购数量" prop="PRODUCT_COUNT">
            <template slot-scope="scope">
              <el-input v-model="scope.row.PRODUCT_COUNT" @change="setActualNumber(scope.row)" clearable>
              </el-input>
            </template>
          </el-table-column>
          <el-table-column label="总金额" prop="TOTAL_FEE"></el-table-column>
          <el-table-column label="备注" prop="PRODUCT_COMMENT">
            <template slot-scope="scope">
              <el-input v-model="scope.row.PRODUCT_COMMENT" clearable>
              </el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button size="small" type="text" @click="deleteProduct(scope.row)" icon="el-icon-close" style="color: #f56c6c">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { getActionFun } from 'api/login';
import http from '@/assets/common/http';
import util from '../../assets/common/util';
import validation from '@/assets/common/validation';

export default {
  data() {
    return {
      fromName: ['lowPriceOrderList'],
      toName: [],
      PAGE_ID: '1001502', // 页面ID 一旦规定不要轻易改动
      fun_dic: {},
      titleData: JSON.parse(sessionStorage.getItem('addLowPriceOrderTitle')),
      totalFee: 0,
      tableData: [],
      addForm: {},
      firstFormadd: {
        productName: '',
        productCode: '',
      },
      enterFlag: 0,
    };
  },
  methods: {
    // 控制功能按钮
    queryBeforeFun() {
      const params = {
        PAGE_ID: this.PAGE_ID,
      };
      getActionFun(params).then((result) => {
        if (result.length !== 0) {
          this.forMenu(result, this.fun_dic);
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    forMenu(e) {
      const tmp_fun_list = e;
      for (let i = 0; i < tmp_fun_list.length; i++) {
        for (const key in this.fun_dic) {
          if (tmp_fun_list[i].FUNCTION_NUM == key) {
            this.fun_dic[key] = 1;
          }
        }
      }
    },
    // input框回车自动聚焦下一个input框
    handelTab(i, e) {
      if (i == 3 && !validation.价格正数0验证(this.addForm.PRICE)) {
        this.$message.show({ text: '请输入正确的价格', type: 'warning' });
        return;
      }
      if (i == 4) {
        if (util.JudgmentUnit(this.addForm.TYPE_UNIT)) {
          if (!validation.数量正数验证(this.addForm.PRODUCT_COUNT)) {
            this.$message.show({ text: '请输入正确的价格', type: 'warning' });
            return;
          }
        } else {
          if (!validation.数量整数正数验证(this.addForm.PRODUCT_COUNT)) {
            this.$message.show({ text: '请输入整数的价格', type: 'warning' });
            return;
          }
        }
      }
      if (this.enterFlag == 1) {
        this.enterFlag = 0;
        return false;
      }
      const that = this;
      if (that.$refs[`input${i}`]) {
        that.$nextTick(() => {
          e.target.blur();
          const index = i + 1;
          that.$refs[`input${index}`].focus();
        });
      }
    },
    // 提交手动录入数据以及重新聚焦第一个input框
    handelTabSp(e) {
      this.submitAdd();
      e.target.blur();
      this.$refs.input1.focus();
    },
    handelTabSpClick(e) {
      this.submitAdd();
      this.$refs.input1.focus();
    },
    handelTabKeyDown(e) {
      this.enterFlag = 1;
      e.target.blur();
      this.handelTabSpClick();
    },
    querySearchadd(queryString, callback) {
      this.$_getSearchRushOrderList(queryString).then((res) => {
        const tmpArr = res.map((item) => ({
          CATALOG_NAME: item.CATALOG_NAME,
          NAME: item.NAME,
          PRICE: item.PRICE,
          PRODUCT_CODE: item.PRODUCT_CODE,
          TYPE_UNIT: item.TYPE_UNIT,
        }));
        const results = tmpArr.map((item) => {
          item.value = `${item.NAME}(${item.TYPE_UNIT})`;
          return item;
        });
        callback(results);
      });
    },
    // 挑选
    handleSelect(item) {
      this.addForm = item;
      this.firstFormadd.productCode = item.PRODUCT_CODE.toString();
    },
    querySearchCodeadd(queryString, callback) {
      this.$_getSearchRushOrderList(queryString).then((res) => {
        const tmpArr = res.map((item) => ({
          CATALOG_NAME: item.CATALOG_NAME,
          NAME: item.NAME,
          PRICE: item.PRICE,
          PRODUCT_CODE: item.PRODUCT_CODE,
          TYPE_UNIT: item.TYPE_UNIT,
        }));
        const results = tmpArr.map((item) => {
          item.value = item.PRODUCT_CODE;
          return item;
        });
        callback(results);
      });
    },
    handleSelectCode(item) {
      this.addForm = item;
      this.firstFormadd.productName = `${item.NAME}(${item.TYPE_UNIT})`;
      this.firstFormadd.productCode = item.PRODUCT_CODE.toString();
    },
    $_getSearchRushOrderList() {
      const data = {
        SERVICE_ID: '10004',
        OTYPE: 50,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
      };
      if (this.firstFormadd.productName) {
        data.PRODUCT_NAME = this.firstFormadd.productName;
      }
      if (this.firstFormadd.productCode) {
        data.PRODUCT_CODE = this.firstFormadd.productCode;
      }
      return new Promise((resolve, reject) => {
        http.post(data).then((res) => {
          resolve(res);
        });
      });
    },
    // ---------------------------添加·产品·确认·按钮
    submitAdd() {
      this.addOrderProduct();
    },
    addOrderProduct() {
      if (!this.firstFormadd.productName) {
        this.$message.show({ text: '请输入产品名称', type: 'warning' });
        return false;
      }
      if (this.titleData.DK_NAME == '仓库') {
        if (!validation.价格正数验证(this.addForm.PRICE)) {
          this.$message.show({ text: '请输入正数单价', type: 'warning' });
          return false;
        }
      } else {
        if (!validation.价格正数0验证(this.addForm.PRICE)) {
          this.$message.show({ text: '请输入正数单价', type: 'warning' });
          return false;
        }
      }
      if (util.JudgmentUnit(this.addForm.TYPE_UNIT)) {
        if (!validation.数量正数验证(this.addForm.PRODUCT_COUNT)) {
          this.$message.show({ text: '请输入正数的数量', type: 'warning' });
          return false;
        }
      } else {
        if (!validation.数量整数正数验证(this.addForm.PRODUCT_COUNT)) {
          this.$message.show({ text: '单位不是KG或斤的，只能输入整数', type: 'warning' });
          return false;
        }
      }
      if (this.tableData.find((item) => item.PRODUCT_CODE == this.addForm.PRODUCT_CODE)) {
        this.$message.show({ text: '已添加该产品，请勿重复添加', type: 'warning' });
        return false;
      }
      this.tableData.push({
        ...this.addForm,
        TOTAL_FEE: (Number(this.addForm.PRICE) * Number(this.addForm.PRODUCT_COUNT)).toFixed(2),
      });
      this.totalFee = this.tableData.reduce((total, curr) => total += Number(curr.PRICE) * Number(curr.PRODUCT_COUNT), 0).toFixed(2);
      this.firstFormadd.productName = '';
      this.firstFormadd.productCode = '';
      this.addForm = {};
    },
    // 改变订购数量触发
    setActualNumber(row) {
      if (!validation.价格正数0验证(row.PRICE)) {
        this.$message.show({ text: '请输入正确的价格', type: 'warning' });
        row.PRICE = '';
        return false;
      }
      if (row.PRICE == 0 && this.titleData.DK_NAME == '仓库') {
        this.$message.show({ text: '仓库订单单价不能为0', type: 'warning' });
        row.PRICE = '';
        return false;
      }
      if (util.JudgmentUnit(row.TYPE_UNIT)) {
        if (!validation.数量正数验证(row.PRODUCT_COUNT)) {
          this.$message.show({ text: '请输入正确的数量', type: 'warning' });
          row.PRODUCT_COUNT = '';
          return false;
        }
      } else {
        if (!validation.数量整数正数验证(row.PRODUCT_COUNT)) {
          this.$message.show({ text: '请输入正确的数量', type: 'warning' });
          row.PRODUCT_COUNT = '';
          return false;
        }
      }
      row.TOTAL_FEE = (Number(row.PRICE) * Number(row.PRODUCT_COUNT)).toFixed(2);
    },
    // ----------------------------删除操作
    deleteProduct({ PRODUCT_CODE }) {
      this.$confirm('确定从订单中删除此商品吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.tableData = this.tableData.filter((item) => item.PRODUCT_CODE != PRODUCT_CODE);
      }).catch(() => {
        this.$message.show({ type: 'info', text: '已取消删除' });
      });
    },
    // 发起到待送
    launchAllOrder() {
      if (this.tableData.length == 0) {
        this.$message.show({ text: '无法创建空订单', type: 'warning' });
        return false;
      }
      // for循环遍历，终止条件是tableData的长度
      const l = this.tableData.length;
      for (let i = 0; i < l; i++) {
        if (!this.tableData[i].PRODUCT_COMMENT) {
          this.tableData[i].PRODUCT_COMMENT = '';
        }
      }

      const {
        TC_ID, PROJECT_ID, DK_ID, SEND_DAY,
      } = this.titleData;
      const params = {
        SERVICE_ID: '10004',
        OTYPE: 46,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        TC_ID,
        PROJECT_ID,
        DK_ID,
        SEND_DAY,
        PRODUCT_LIST: this.tableData,
      };
      http.post(params).then((result) => {
        this.$message.show({ text: '订单录入成功', type: 'success' });
        this.tableData = [];
        setTimeout(() => {
          this.$router.push({ name: 'lowPriceOrderList' });
        }, 100);
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.tableData.length) {
      this.$confirm('正在离开本页面，已添加的产品数据将会丢失，确定要离开吗？', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        next();
      }).catch((err) => {
        // eslint-disable-next-line no-console
        console.log(err);
      });
    } else {
      next();
    }
    sessionStorage.removeItem('addLowPriceOrderTitle');
  },
  beforeRouteEnter(to, from, next) {
    next((that) => {
      // 判断是否通过修改URL进入
      if (!that.fromName.includes(from.name) || !sessionStorage.getItem('addLowPriceOrderTitle')) {
        that.$message.show({ text: '请从单外订单点击录入订单进入', type: 'warning' });
        that.$router.go(-1);
      }
    });
  },
};
</script>
<style scoped>
.inline-input {
  width: 390px;
}

.el-autocomplete-suggestion {
  width: 420px !important;
}

ul li span {
  display: inline-block;
  width: 70px;
  text-align-last: justify;
}

ul {
  list-style: none;
  min-height: 100px;
  padding: 0;
}

ul li {
  margin-bottom: 0;
  line-height: 25px;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/sellOrderManage/addLowPriceOrder.vue